import PageTitle from '../../components/CommonComps/Titles/PageTitle';
import CityModalContainer from '../../components/SetupSubPageComps/CitiesComps/CityModalContainer';
import ShowAllCities from '../../components/SetupSubPageComps/CitiesComps/ShowAllCities';
import CityProvider from '../../contexts/CityProvider';

const Cities = () => {
  // rendering cities page component here
  return (
    <>
      <PageTitle title='Cities' />

      <CityProvider>
        <ShowAllCities />
        <CityModalContainer />
      </CityProvider>
    </>
  );
};

export default Cities;
